import React from "react"
import moment from "moment-timezone"
import { useAuth } from "../../services"

export default ({ value }) => {
  const { location } = useAuth()

  try {
    return <>{value && moment(value).tz(location.timeZone).format("Do MMM YYYY hh:mm a z")}</>
  } catch (ex) {
    return <>Data invalid.</>
  }
}
